import type { Idioma } from './idiomas';
import { IDIOMAS } from './idiomas';

import esComun from './locales/es/comun.json';
import esGestion from './locales/es/gestion.json';
import esLocalizacion from './locales/es/localizacion.json';
import esAndenes from './locales/es/andenes.json';

import enComun from './locales/en/comun.json';
import enGestion from './locales/en/gestion.json';
import enLocalizacion from './locales/en/localizacion.json';
import enAndenes from './locales/en/andenes.json';

import ptComun from './locales/pt/comun.json';
import ptGestion from './locales/pt/gestion.json';
import ptLocalizacion from './locales/pt/localizacion.json';
import ptAndenes from './locales/pt/andenes.json';

import glComun from './locales/gl/comun.json';
import glGestion from './locales/gl/gestion.json';
import glLocalizacion from './locales/gl/localizacion.json';
import glAndenes from './locales/gl/andenes.json';

import caComun from './locales/ca/comun.json';
import caGestion from './locales/ca/gestion.json';
import caLocalizacion from './locales/ca/localizacion.json';
import caAndenes from './locales/ca/andenes.json';

import euComun from './locales/eu/comun.json';
import euGestion from './locales/eu/gestion.json';
import euLocalizacion from './locales/eu/localizacion.json';
import euAndenes from './locales/eu/andenes.json';

/** Los cuatro espacios de nombres en que se reparten los textos del panel. */
export const NAMESPACES = ['comun', 'gestion', 'localizacion', 'andenes'] as const;

export type Namespace = (typeof NAMESPACES)[number];

type Arbol = { [clave: string]: string | Arbol };

const ARBOLES: Record<Idioma, Record<Namespace, Arbol>> = {
    es: { comun: esComun, gestion: esGestion, localizacion: esLocalizacion, andenes: esAndenes },
    en: { comun: enComun, gestion: enGestion, localizacion: enLocalizacion, andenes: enAndenes },
    pt: { comun: ptComun, gestion: ptGestion, localizacion: ptLocalizacion, andenes: ptAndenes },
    gl: { comun: glComun, gestion: glGestion, localizacion: glLocalizacion, andenes: glAndenes },
    ca: { comun: caComun, gestion: caGestion, localizacion: caLocalizacion, andenes: caAndenes },
    eu: { comun: euComun, gestion: euGestion, localizacion: euLocalizacion, andenes: euAndenes },
};

/**
 * Aplana `{ nav: { dashboard: 'Panel' } }` a `{ 'nav.dashboard': 'Panel' }`. El
 * JSON se escribe anidado porque así es legible para quien traduce, pero las
 * búsquedas en caliente se hacen sobre el mapa plano.
 */
function aplanar(arbol: Arbol, prefijo: string, destino: Map<string, string>): void {
    for (const [clave, valor] of Object.entries(arbol)) {
        const ruta = prefijo ? `${prefijo}.${clave}` : clave;
        if (typeof valor === 'string') {
            destino.set(ruta, valor);
        } else {
            aplanar(valor, ruta, destino);
        }
    }
}

const PLANOS = new Map<Idioma, Map<string, string>>();

for (const idioma of IDIOMAS) {
    const plano = new Map<string, string>();
    for (const ns of NAMESPACES) {
        aplanar(ARBOLES[idioma][ns], ns, plano);
    }
    PLANOS.set(idioma, plano);
}

export function diccionario(idioma: Idioma): Map<string, string> {
    return PLANOS.get(idioma)!;
}

/** Usado por la prueba de paridad de claves. */
export function clavesDe(idioma: Idioma): string[] {
    return [...diccionario(idioma).keys()].sort();
}
